export default {
    empty(val) {
        if (val == '' || val == undefined || val == null || val == '0' || Object.keys(val).length == 0) {
            return true;
        }
        return false;
    },
    float(amount) {
        amount = parseFloat(amount);
        amount = amount ? amount : 0;
        return parseFloat(amount.toFixed(2));
    },
    float_str(amount) {
        amount = parseFloat(amount);
        amount = amount ? amount : 0;
        return amount.toFixed(2);
    },
    calc_tax($amount, $is_tax) {
        let $tax_total = 0;
        if ($is_tax['type'] == 1) {
            return $tax_total;
        }
        if(!$is_tax['value']){
            return 0
        }
        let $temp = $is_tax['value'].split(',');
        let $tax = [];
        let $n = 0;
        for (var $i in $temp) {
            let $v = $temp[$i].split(':');
            $tax_total += $amount * $v[1] / 100;
        }
        return this.float($tax_total);
    },
    currency_change(that, goods_booking_data) {
        if (goods_booking_data.coupon_select == 2 && !that._func.empty(goods_booking_data.coupon)) {
            that._order.coupon_check(that, goods_booking_data, 2)
        } else if (goods_booking_data.coupon_select == 1 && !that._func.empty(goods_booking_data.my_coupon)) {
            goods_booking_data.my_coupon = {}
            that.order_amount()
            that.onCouponMy()
        } else {
            that.order_amount()
        }
    },
    order_tax($goods, $base_amount, $tax_base_amount, $discount_amount, $tax_fee, rate, no_coupon_amt, tax) {
        $discount_amount = Math.abs($discount_amount);
        $discount_amount = Math.min($base_amount, $discount_amount);
        no_coupon_amt = no_coupon_amt ? no_coupon_amt : 0
        if ($discount_amount <= 0) {
            $discount_amount = 0
        }
        $base_amount -= no_coupon_amt
        var $percent_tax = $discount_amount / $base_amount;
        var $tax_total = 0
        var t = {}
        var $val = ''
        var $amt = ''
        var $discount_price = 0
        for (var i in $goods) {
            $val = $goods[i]
            $amt = $val['amount']
            $amt *= rate
            $discount_price = 0
            if ($val.join_platform_coupon == 1) {
                $discount_price = $amt * $percent_tax
            }
            if ($val.have_tax == 1) {
                t = {
                    type: 2,
                    value: tax
                }
            } else {
                t = {
                    type: 1,
                    value: 0
                }
            }
            $tax_total += this.calc_tax(($amt - $discount_price), t)
        }
        return this.float($tax_total)
    },
    calc_delivery_fee(that,goods_booking_data,info){
        let store_fee = {}
        let delivery_fee = 0
        let cityid = this.get_city_id(goods_booking_data, info)
        for (let i in info.goods_store) {
            let t = info.goods_store[i]
            store_fee[t.store_id] = {}
            store_fee[t.store_id].index = i
            store_fee[t.store_id].amount = 0
            store_fee[t.store_id].delivery = t.delivery
            if(!this.empty(t.delivery_area_fee)){
                if(t.delivery_area_fee[cityid[0]]){
                    store_fee[t.store_id].delivery = t.delivery_area_fee[cityid[0]]
                }else if(t.delivery_area_fee[cityid[1]]){
                    store_fee[t.store_id].delivery = t.delivery_area_fee[cityid[1]]
                }
            }
            for (let ii in t.list) {
                store_fee[t.store_id].amount += parseFloat(t.list[ii].amount)
            }
        }
        for (let i in store_fee) {
            store_fee[i].delivery.delivery_fee = parseFloat(store_fee[i].delivery.delivery_fee)
            store_fee[i].delivery.delivery_fee_free = parseFloat(store_fee[i].delivery.delivery_fee_free)
            let t = 0
            let d = 0
            let index = store_fee[i].index
            if(store_fee[i].amount >= store_fee[i].delivery.delivery_fee_free){
                d = 0
            }else{
                d = store_fee[i].delivery.delivery_fee
            }
            t = store_fee[i].amount + d
            if(d > 0){
                that.goods_store[index].add_on = that._func.$t('goods_add_on',that,that._func.float_str(store_fee[i].delivery.delivery_fee_free - store_fee[i].amount))
            }else{
                that.goods_store[index].add_on = ''
            }
            that.goods_store[index].shipping.fee = that._func.float_str(d)
            that.goods_store[index].total.fee = that._func.float_str(t)
            delivery_fee += d
        }
        return delivery_fee
    },
    tour_order_amount(that, info, tour_booking_data, page_data) {
        var cur = tour_booking_data.currency
        var rate = 1;
        if (cur == info.currency) {
            var amount = tour_booking_data.amount;
            var amount2 = info.amount
        } else {
            rate = info.rate[info.currency][cur].value
            var amount = tour_booking_data.amount * rate;
            var amount2 = info.amount * rate;
        }
       
        amount2 = this.float(amount2)
        page_data.amount = amount2

        var c_amount = this.float(amount)
        var ext = this.calc_coupon(tour_booking_data, c_amount, c_amount, cur, 0, that)

        that.temp_coupon_html = ext.html
        page_data.discount = ext.sub_amount
        var calc_list = {
            symbol: '',
            currency: '',
            amount: '',
        }
        if (cur == info.currency) {
            calc_list = {
                symbol: info.symbol,
                currency: info.currency,
                amount: ext.total_amount,
            }
        } else {
            calc_list = {
                symbol: info.rate[info.currency][cur].symbol,
                currency: cur,
                amount: ext.total_amount,
            }
        }

        let tax_v = info.tour.tax
        let tax_fee = this.calc_tax(ext.total_amount,tax_v)
        page_data.tax_fee = this.float_str(tax_fee)
        page_data.tax = tax_v
        calc_list.amount = parseFloat(calc_list.amount)
        calc_list.amount += parseFloat(tax_fee)
        calc_list.amount = calc_list.amount < 0 ? 0 : calc_list.amount
        calc_list.amount = this.float_str(calc_list.amount)
        page_data.symbol = calc_list.symbol
        page_data.total = this.float_str(calc_list.amount)
        page_data.currency = calc_list.currency
        page_data.amount = this.float_str(page_data.amount)
        page_data.discount = this.float_str(page_data.discount)
        page_data.attr_amount = this.float_str(tour_booking_data.attr_amount)
        page_data.hotel_amount = this.float_str(tour_booking_data.hotel_amount)
    },
    goods_order_amount(that, info, goods_booking_data, page_data) {
        var cur = goods_booking_data.currency
        var select_addr = goods_booking_data.select_addr
        var rate = 1;
        var delivery_amt = 0.00;
        if (cur == info.currency) {
            var amount = info.amount;
            var amount2 = info.amount
            var no_coupon_amt = info.no_coupon_amt
            var tax_fee = info.tax_fee
            var tax_base_amount = info.tax_base_amount
        } else {
            rate = info.rate[info.currency][cur].value
            var amount = info.amount * rate;
            var amount2 = info.amount * rate;
            var no_coupon_amt = info.no_coupon_amt * rate;
            var tax_fee = info.tax_fee * rate;
            var tax_base_amount = info.tax_base_amount * rate;
        }
        if(select_addr == 1){
            delivery_amt = this.calc_delivery_fee(that,goods_booking_data,info)
            delivery_amt = delivery_amt * rate;
        }
        amount2 = this.float(amount2)
        delivery_amt = this.float(delivery_amt)
        page_data.amount = amount2

        no_coupon_amt = this.counpon_use_tag(goods_booking_data,no_coupon_amt)
        var c_amount = this.float(amount - no_coupon_amt)
        var ext = this.calc_coupon(goods_booking_data, c_amount, c_amount, cur, no_coupon_amt, that)

        that.temp_coupon_html = ext.html
        page_data.discount = ext.sub_amount
        var calc_list = {
            symbol: '',
            currency: '',
            amount: '',
        }
        if (cur == info.currency) {
            calc_list = {
                symbol: info.symbol,
                currency: info.currency,
                amount: ext.total_amount,
            }
        } else {
            calc_list = {
                symbol: info.rate[info.currency][cur].symbol,
                currency: cur,
                amount: ext.total_amount,
            }
        }
        let tax_v = this.get_tax(goods_booking_data, info)
        tax_fee = this.order_tax(goods_booking_data.goods, amount2, tax_base_amount, ext.sub_amount, tax_fee, rate, no_coupon_amt, tax_v)
        page_data.tax_fee = tax_fee
        page_data.tax = tax_v
        page_data.delivery_amt = delivery_amt
        calc_list.amount = parseFloat(calc_list.amount)
        calc_list.amount += parseFloat(tax_fee)
        calc_list.amount += parseFloat(delivery_amt)
        calc_list.amount = calc_list.amount < 0 ? 0 : calc_list.amount
        calc_list.amount = this.float(calc_list.amount)
        page_data.symbol = calc_list.symbol
        page_data.total = calc_list.amount
        page_data.currency = calc_list.currency
    },
    get_tax(goods_booking_data, info) {
        let goods_tax = ''
        if (goods_booking_data.select_addr == 1) {
            for (var i in info.select_addr[1].list) {
                if (goods_booking_data.receive == info.select_addr[1].list[i].id) {
                    return info.select_addr[1].list[i].tax
                }
            }
        } else {
            for (var i in info.select_addr[2].list) {
                for (var ii in info.select_addr[2].list[i].list) {
                    if (info.select_addr[2].list[i].list[ii].id == goods_booking_data.leader_id) {
                        return info.select_addr[2].list[i].list[ii].tax
                    }
                }
            }
        }
    },
    get_city_id(goods_booking_data, info) {
        for (var i in info.select_addr[1].list) {
            if (goods_booking_data.receive == info.select_addr[1].list[i].id) {
                return info.select_addr[1].list[i].cityid.split('-')
            }
        }
    },
    coupon_check(that, booking_data, type = 1) {
        if (!that.temp_coupon) {
            if (booking_data.coupon_select == 2) {
                booking_data.coupon = {}
                that.order_amount()
            }
            return
        }
        let params = that.info.url.check_coupon.parame
        params += '&currency='+booking_data.currency
        params += '&coupon_code='+that.temp_coupon

        that._ajax.post_form(that.info.url.check_coupon.url, params, that).then(res => {
            if (res !== false) {
                booking_data.coupon = res
                booking_data.my_coupon = {}
                booking_data.coupon_select = 2
            } else {
                booking_data.coupon = {}
                that.temp_coupon = ''
                //booking_data.my_coupon = {}
            }
            that.order_amount()
        })
    },
    coupon_select(that, booking_data, data) {
        booking_data.coupon_select = 1
        booking_data.my_coupon = data
        that.order_amount()
        that.my_coupon_show = false
    },
    coupon_clear(that, booking_data) {
        booking_data.coupon = {}
        booking_data.coupon_select = 0
        booking_data.my_coupon = {}
        that.temp_coupon = ''
        that.order_amount()
    },
    coupon_my(currency, that, booking_data, type = 1) {
        let params = that.info.url.check_my_coupon.parame
        params += '&currency='+currency
        that._ajax.fetch(that.info.url.check_my_coupon.url, params, that).then(res => {
            if (res) {
                booking_data.coupon = {}
                that.temp_coupon = ''
                that.my_coupon_list = res
                that.my_coupon_show = true
            } else {
                that.my_coupon_show = false
            }
            /*else {
                   booking_data.my_coupon = {}
                   //that.temp_coupon = ''
                   that.my_coupon_list = {}
                 }*/
        })
    },
    counpon_use_tag(data,no_coupon_amt){
        no_coupon_amt = this.float(no_coupon_amt)
        var c_id = ''
        var counpon_use_tag_id = 0

        if(data.my_coupon.id){
            c_id = data.my_coupon.id
            counpon_use_tag_id = data.my_coupon.use_tag_id
        }else if(data.coupon.coupon_id){
            c_id = data.coupon.coupon_id
            counpon_use_tag_id = data.coupon.use_tag_id
        }

        if(c_id && counpon_use_tag_id > 0){
            for (var i in data.goods) {
                if(data.goods[i].join_platform_coupon == 1){
                    if(!data.goods[i].tag_ids[counpon_use_tag_id]){
                        no_coupon_amt += this.float(data.goods[i].amount)
                    }
                }
            }
        }
        return no_coupon_amt;
    },
    calc_coupon(parame, total_amount, base_amount, cur, no_coupon_amt, that) {
        no_coupon_amt = no_coupon_amt ? no_coupon_amt : 0
        var o_total_amount = total_amount
        var discount = {
            coupon: ''
        };
        var html = ''
        var sub_amount = 0
        var max_amount = 0
        if (parame.coupon_select == 2) {
            if (!this.empty(parame.coupon)) {
                sub_amount = 0;
                if (parame.coupon.amount) {
                    sub_amount = this.float(parame.coupon.amount);
                    max_amount = this.float(parame.coupon.max_amount);
                    if (parseFloat(max_amount) <= parseFloat(total_amount)) {
                        total_amount -= sub_amount
                        discount.coupon = '<dl><dt>' + parame.coupon.coupon_code + '</dt><dd class="line"></dd><dd>- ' + sub_amount + ' ' + cur + '</dd></dl>';
                    } else {
                        sub_amount = 0
                        that._func.toast('coupon_cdt', that)
                        parame.my_coupon = {}
                        parame.coupon = {}
                        parame.coupon_select = 0
                    }
                } else if (parame.coupon.discount) {
                    sub_amount = base_amount * (1 - parame.coupon.discount);
                    sub_amount = this.float(sub_amount);
                    total_amount -= sub_amount;
                    discount.coupon = '<dl><dt>' + parame.coupon.coupon_code + '</dt><dd class="line"></dd><dd>- ' + sub_amount + '<em>(' + parame.coupon.title + ')</em></dd></dl>';
                }
            }
            //parame.my_coupon = {};
        } else if (parame.coupon_select == 3) {
            if (!this.empty(parame.point)) {
                sub_amount = parame.point.amount;
                sub_amount = this.float(sub_amount);
                total_amount -= sub_amount;
                if (parame.point.point) {
                    discount.coupon = '<dl><dt>' + js_lang.label_point + parame.point.point + '</dt><dd class="line"></dd><dd>- ' + sub_amount + ' ' + cur + '</dd></dl>';
                }
            }
            //parame.my_coupon = {};
        } else if (parame.coupon_select == 1) {
            if (!this.empty(parame.my_coupon)) {
                if (parame.my_coupon.discount) {
                    sub_amount = base_amount * (1 - parame.my_coupon.discount);
                    sub_amount = this.float(sub_amount);
                    total_amount -= sub_amount;
                    discount.coupon = '<dl><dt>' + parame.my_coupon.code + '</dt><dd class="line"></dd><dd>- ' + sub_amount + cur + '<em>(' + parame.my_coupon.text + ')</em></dd></dl>';
                } else if (parame.my_coupon.total) {
                    if (parseFloat(parame.my_coupon.total) <= parseFloat(base_amount)) {
                        sub_amount = parame.my_coupon.price;
                        sub_amount = this.float(sub_amount);
                        total_amount -= sub_amount;
                        discount.coupon = '<dl><dt>' + parame.my_coupon.code + '</dt><dd class="line"></dd><dd>- ' + sub_amount + cur + '<em>(' + parame.my_coupon.text + ')</em></dd></dl>';
                    } else {
                        that._func.toast('coupon_cdt', that)
                        parame.my_coupon = {}
                        parame.coupon = {}
                        parame.coupon_select = 0
                    }
                } else if (!parame.my_coupon.total) {
                    sub_amount = parame.my_coupon.price;
                    sub_amount = this.float(sub_amount);
                    total_amount -= sub_amount;
                    discount.coupon = '<dl><dt>' + parame.my_coupon.code + '</dt><dd class="line"></dd><dd>- ' + sub_amount + ' ' + cur + '</dd></dl>';
                }
            }
        }
        for (var n in discount) {
            html += discount[n]
        }
        no_coupon_amt = this.float(no_coupon_amt)
        total_amount = this.float(total_amount)
        sub_amount = this.float(sub_amount)
        if (total_amount < 0) {
            sub_amount = o_total_amount
        }
        total_amount = total_amount < 0 ? 0 : total_amount
        total_amount += no_coupon_amt
        return {
            html: html,
            total_amount: this.float(total_amount),
            sub_amount: this.float(sub_amount * -1)
        }
    },
    ckTourPrice(that, parame,hotel_data) {
        let data = {}
        let attr_list = {}
        if (!this.empty(parame)) {
            for (var i in parame) {
                if (!parame[i].list) {
                    data[i] = {
                        list: parame[i].list
                    }
                } else if (!that._func.is_arr_obj(parame[i].list)) {
                    data[i] = {
                        list: parame[i].list
                    }
                } else {
                    data[i] = {
                        list: {}
                    }
                    for (var ii in parame[i].list) {
                        if (!isNaN(ii)) {
                            if (typeof(parame[i].list[ii].item) !== 'undefined') {
                                data[i].list[ii] = {
                                    item: {}
                                }
                                for (var iii in parame[i].list[ii].item) {
                                    if (parame[i].list[ii].item[iii]) {
                                        data[i].list[ii].item[iii] = parame[i].list[ii].item[iii]
                                    }
                                }
                            } else {
                                data[i].list[parseInt(parame[i].list[ii])] = 1
                            }
                        } else {
                            data[i].list[ii] = parame[i].list[ii]
                        }
                    }
                }
            }
            for (var n in that.info.value_added) {
                for (var nn in that.info.value_added[n]) {
                    let mm = that.info.value_added[n][nn]
                    //if (mm.price != 1) continue
                    attr_list[mm.id] = {
                        id: mm.id,
                        title: mm.title,
                        type: mm.type,
                        price: mm.price,
                        list: {}
                    }
                    for (var nnn in mm.list) {
                        let mmm = mm.list[nnn]
                        if (mm.type == 10) {
                            if (this.empty(mmm.item)) {
                                if (data[mm.id].list[nnn]) {
                                    attr_list[mm.id].list[nnn] = {
                                        'title': mmm.title,
                                        'price': mmm.price,
                                        item: {}
                                    }
                                }
                            } else {
                                for (var nnnn in mmm.item) {
                                    let mmmm = mmm.list[nnnn]
                                    if (data[mm.id].list[nnn].item[nnnn]) {
                                        if (mmmm.price) {
                                            attr_list[mm.id].list[nnn].item[nnnn] = {
                                                'title': mmmm.title,
                                                'price': mmmm.price
                                            }
                                        } else {
                                            attr_list[mm.id].list[nnn].item[nnnn] = {
                                                'title': mmmm.title,
                                                'price': ''
                                            }
                                        }
                                    }
                                }
                            }
                        } else if (mm.type == 11) {
                            if (that._func.inArray(data[mm.id].list.id,nnn)) {
                                if (this.empty(mmm.item)) {
                                    if (data[mm.id].list[nnn]) {
                                        attr_list[mm.id].list[nnn] = { 
                                            'title': mmm.title, 
                                            'price': mmm.price, 
                                            item: {} 
                                        }
                                    }
                                } else {
                                    for (var nnnn in mmm.item) {
                                        let mmmm = mmm.item[nnnn]
                                        var temp = typeof(data[mm.id].list[nnn].item[nnnn]) !== "undefined" ? data[mm.id].list[nnn].item[nnnn] : false;
                                        if (mm.price == 1) {
                                            temp = parseInt(temp);
                                            temp = temp > 0 ? temp : 0;
                                        }
                                        if (data[mm.id].list[nnn].item[nnnn]) {

                                            if (!attr_list[mm.id].list[nnn]) {
                                                attr_list[mm.id].list[nnn] = { item: {},title:mmm.title,price:0}
                                            }
                                            if (mm.price == 1 && mmmm.price) {
                                                attr_list[mm.id].list[nnn].price += temp * mmmm.price
                                                attr_list[mm.id].list[nnn].item[nnnn] = { 'title': mmmm.title + ' ✕ ' + temp, 'value': ' ✕ ' + temp,'price': temp * mmmm.price }
                                            } else {
                                                attr_list[mm.id].list[nnn].item[nnnn] = { 'title': mmmm.title , 'value': ' ✕ ' + temp,'price': '' }
                                            }
                                        }
                                    }
                                }
                            }
                        }else if (mm.type == 30) {
                            for (var nnnn in mmm.item) {
                                let mmmm = mmm.item[nnnn]
                                var temp = typeof(data[mm.id].list[nnn].item[nnnn]) !== "undefined" ? data[mm.id].list[nnn].item[nnnn] : false;
                                if (mm.price == 1) {
                                    temp = parseInt(temp);
                                    temp = temp > 0 ? temp : 0;
                                }
                                if (temp) {
                                    if (!attr_list[mm.id].list[nnn]) {
                                        attr_list[mm.id].list[nnn] = {
                                            item: {}
                                        }
                                    }
                                    if (mm.price == 1) {
                                        attr_list[mm.id].list[nnn].item[nnnn] = {
                                            'title': mmmm.title + ' ✕ ' + temp,
                                            'value': ' ✕ ' + temp,
                                            'price': temp * mmmm.price
                                        }
                                    } else {
                                        attr_list[mm.id].list[nnn].item[nnnn] = {
                                            'title': mmmm.title + ' ✕ ' + temp,
                                            'value': '',
                                            'price': ''
                                        }
                                    }
                                }
                            }
                        } else {
                            if (this.empty(mmm.item)) {
                                if (data[mm.id].list.id && data[mm.id].list.id == nnn) {
                                    attr_list[mm.id].list[data[mm.id].list.id] = {
                                        'title': mmm.title,
                                        'price': mmm.price,
                                        item: {}
                                    }
                                } else if (data[mm.id].list && data[mm.id].list == nnn) {
                                    attr_list[mm.id].list[data[mm.id].list] = {
                                        'title': mmm.title,
                                        'price': mmm.price,
                                        item: {}
                                    }
                                    if(mmm.value_title){
                                        for (var nnnn in mmm.value_title) {
                                            let mmmm = mmm.value_title[nnnn]
                                            data[mm.id].list.id
                                            attr_list[mm.id].list[data[mm.id].list].item[nnnn] = { 'title': mmmm.title, 'value': mmmm.value ? mmmm.value : '' }
                                        }
                                    }
                                }
                            } else {
                                if (data[mm.id].list.id && data[mm.id].list.id == nnn) {
                                    attr_list[mm.id].list[data[mm.id].list.id] = {
                                        'title': mmm.title,
                                        'price': mmm.price,
                                        item: {}
                                    }
                                    for (var nnnn in mmm.item) {
                                        let mmmm = mmm.item[nnnn]
                                        var temp = typeof(data[mm.id].list[nnn].item[nnnn]) !== "undefined" ? data[mm.id].list[nnn].item[nnnn] : false;
                                        if (!attr_list[mm.id].list[nnn].item) {
                                            attr_list[mm.id].list[nnn].item = {};
                                        }
                                        attr_list[mm.id].list[nnn].item[nnnn] = {
                                            'title': mmmm.title,
                                            'value': temp
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        var amount = that.info.amount;
        var html = '';
        var shtml = '';
        var attr_amount = 0;
        for (var n in attr_list) {
            let m = attr_list[n]
            if (!this.empty(m.list)) {
                if (m.price == 1) {
                    html += '<fieldset>';
                    html += '<legend>' + m.title + '</legend>';
                    for (var nn in m.list) {
                        let mm = m.list[nn]
                        if (m.type != 30) {
                            if (mm.price  && m.type != 11) {
                                attr_amount += parseInt(mm.price * 100) / 100;
                            }
                            html += '<dl><dt>' + mm.title + '</dt><dd class="flex-1"></dd><dd class="price">' + that.info.symbol + mm.price + ' ' + that.info.currency + '</dd></dl>';
                        }
                        if (!this.empty(mm.item)) {
                            html += '<div class="m-b-left">'
                            for (var nnn in mm.item) {
                                let mmm = mm.item[nnn]
                                if (mmm.price || mmm.price === 0) {
                                    attr_amount += parseInt(mmm.price * 100) / 100;
                                    html += '<dl><dt>' + mmm.title + '</dt><dd class="flex-1 no-total"></dd><dd class="price">' + that.info.symbol + mmm.price + ' ' + that.info.currency + '</dd></dl>';
                                } else {
                                    if(mmm.value){
                                        if(!isNaN(mmm.value) && m.type == 21 ){
                                            html += '<dl ><dt>' + mmm.title + '</dt><dd class="line"></dd><dd>' + that.info.symbol + mmm.value + ' ' + that.info.currency + '</dd></dl>';
                                        }else{
                                            if (m.type == 31) {
                                                html += '<dl ><dt>' + mmm.title + '</dt><dd class="line"></dd><dt>' + (mmm.value) + '</dt></dl>';
                                            }else{
                                                html += '<dl ><dt>' + mmm.title + '</dt><dd class="line"></dd><dd>' + (mmm.value) + '</dd></dl>';
                                            }
                                        }
                                    }else{
                                        if (m.type == 31 && mmm.value) {
                                            html += '<dl ><dt>' + mmm.title + '</dt><dd class="flex-1"></dd><dt>' + (mmm.value) + '</dt></dl>';
                                        }else if(m.type != 31){
                                            html += '<dl ><dt>' + mmm.title + '</dt><dd class="flex-1"></dd><dd>' + (mmm.value) + '</dd></dl>';
                                        }
                                    }
                                }
                            }
                            html += '</div>'
                        }
                    }
                    html += '</fieldset>';
                } else {
                    shtml += '<fieldset>';
                    shtml += '<legend >' + m.title + '</legend>';
                    for (var nn in m.list) {
                        let mm = m.list[nn]
                        if (m.type != 30) {
                            shtml += '<dl><dt>' + mm.title + '</dt><dd class="flex-1"></dd><dd></dd></dl>';
                        }
                        for (var nnn in mm.item) {
                            let mmm = mm.item[nnn]
                            if (mmm.price) {
                                shtml += '<dl><dt>' + mmm.title + '</dt><dd class="flex-1"></dd><dd></dd></dl>';
                            } else {
                                if (m.type == 31 && mmm.value || m.type != 31) {
                                    shtml += '<dl><dt>' + mmm.title + '</dt><dd class="line"></dd><dd class="amt-1">' + (mmm.value) + '</dd></dl>';
                                }
                            }
                        }
                    }
                    shtml += '</fieldset>';
                }
            }
        }
        amount += attr_amount

        var hotel_list = {}
        for (var index in that.info.tour.hotel.flag) {
            var el = that.info.tour.hotel.flag[index]
            if(!el || !hotel_data[index] ||  !hotel_data[index].id)continue
            var h_id = hotel_data[index].id
            var h_room = hotel_data[index].room
            var h_date = hotel_data[index].date
            hotel_list[index] = {
                title:that.$t('label_hotel_'+index),
                hotel:'『 '+that.info.tour.hotel.data[h_id].info.hotel_code+' 』 '+that.info.tour.hotel.data[h_id].info.title,
                amount:0.00,
                list:{}
            }
            let num = that._func.objLen(that.info.tour.hotel.data[h_id][index].items[h_date].in_date)
            for (var ii in that.info.tour.hotel.data[h_id][index].items[h_date].in_date) {
                var ss = that.info.tour.hotel.data[h_id][index].items[ii].list
                for (var iii in ss) {
                    var nnn = ss[iii]
                    if(h_room[iii]){
                        var am = parseInt(nnn.price*h_room[iii] * 100) / 100
                        hotel_list[index].amount += am
                        if(!hotel_list[index].list[iii]){
                            hotel_list[index].list[iii] = {
                                title:nnn.title+' ✕ '+h_room[iii],
                                amt:that._func.float_str(am*num)
                            }
                        }
                        
                    }
                }
            }
            hotel_list[index].amount = this.float(hotel_list[index].amount)
        }
        var thtml = '';
        var hotel_s_html = '';
        var hotel_amount = 0
        if(!this.empty(hotel_list)){
            for (var i in hotel_list) {
                thtml += '<dl><dt>' + that.$t('label_hotel_'+i) + '</dt><dd class="line"></dd><dd class="amt-1">' + that.info.symbol + hotel_list[i].amount + ' ' + that.info.currency +  '</dd></dl>';
                amount += parseInt(hotel_list[i].amount * 100) / 100
                hotel_amount += parseInt(hotel_list[i].amount * 100) / 100
                hotel_s_html += '<li><label>' + that.$t('label_hotel_'+i)+'：</label>'+hotel_list[i].hotel + '</li>';
            }
        }
        return {
            amount,
            attr_amount,
            hotel_amount,
            html,
            shtml,
            hotel_list
        }
    },
}